module.exports = __webpack_public_path__ + "static/media/companyculture04.0147b589.png";